import { useState } from 'react';
import { Modal, Input, Button, Typography } from 'antd';

const { Text, Link } = Typography;

const API_KEY_STORAGE_KEY = 'openai_api_key';

export const getStoredApiKey = (): string => {
  return localStorage.getItem(API_KEY_STORAGE_KEY) || process.env.REACT_APP_OPEN_API_KEY || '';
};

export const setStoredApiKey = (key: string): void => {
  localStorage.setItem(API_KEY_STORAGE_KEY, key);
};

interface ApiKeyModalProps {
  open: boolean;
  onSave: (key: string) => void;
  onClose?: () => void;
}

const ApiKeyModal = ({ open, onSave, onClose }: ApiKeyModalProps) => {
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState('');

  const handleSave = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) {
      setError('Please enter an API key.');
      return;
    }
    if (!trimmed.startsWith('sk-')) {
      setError('API key should start with "sk-".');
      return;
    }
    setError('');
    setStoredApiKey(trimmed);
    onSave(trimmed);
  };

  return (
    <Modal
      title="Enter your OpenAI API Key"
      open={open}
      closable={!!onClose}
      maskClosable={!!onClose}
      onCancel={onClose}
      footer={null}
      centered
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <Text type="secondary">
          Sensecape uses OpenAI's GPT-4 to power its features. Your key is stored locally in your browser and never sent anywhere else.
        </Text>
        <Input.Password
          placeholder="sk-..."
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            setError('');
          }}
          onPressEnter={handleSave}
          size="large"
          autoFocus
        />
        {error && <Text type="danger">{error}</Text>}
        <Button type="primary" onClick={handleSave} size="large" block>
          Save & Continue
        </Button>
        <Text type="secondary" style={{ fontSize: 12, textAlign: 'center' }}>
          Get your API key from{' '}
          <Link href="https://platform.openai.com/api-keys" target="_blank">
            platform.openai.com
          </Link>
        </Text>
      </div>
    </Modal>
  );
};

export default ApiKeyModal;
